import React from 'react';
interface AnimatedShinyTextProps {
  children: ReactNode;
  className?: string;
  shimmerWidth?: number;
}
const AnimatedShinyText: FC<AnimatedShinyTextProps> = ({
  children,
  className = '',
  shimmerWidth = 100
}) => {
  return <p style={{
    '--shiny-width': `${shimmerWidth}px`
  } as CSSProperties} className={`
        mx-auto text-white/70 text-sm
        animate-shiny-text bg-clip-text bg-no-repeat 
        [background-position:0_0] 
        [background-size:var(--shiny-width)_100%] 
        [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite]
        bg-gradient-to-r from-transparent via-white/80 via-50% to-transparent
        px-3 py-1
        ${className}
      `} data-id="element-8">
      {children}
    </p>;
};
export { AnimatedShinyText };